import { jsx as t } from "react/jsx-runtime";
import { MenuItem as c } from "@headlessui/react";
import { twMerge as l } from "tailwind-merge";
const m = "group aria-pressed:text-brand-primary hover:text-brand-primary flex items-center gap-2 w-full px-4 py-3 lg:py-2 text-left text-sm transition-colors border-b border-background-tertiary last:border-0", u = ({
  dataTestAttributes: o,
  onClick: a,
  label: s,
  buttonClassName: n,
  labelClassName: i,
  children: e,
  ...r
}) => /* @__PURE__ */ t(c, { ...r, children: e || (({ focus: d }) => /* @__PURE__ */ t(
  "button",
  {
    onClick: a,
    "aria-pressed": d,
    type: "button",
    className: l(
      m,
      r.disabled && "hover:text-text-secondary text-text-secondary cursor-not-allowed",
      n
    ),
    ...o,
    children: /* @__PURE__ */ t("span", { className: i, children: s })
  }
)) }, "action-settings");
export {
  m as ACTION_MENU_ITEM_CLASS_NAME,
  u as ActionMenuItem
};
